'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$41() {
  this.bDh = null;
  this.bDi = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$41 as $c_Lpresto_TwoFactorAuthView$$anon$41 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$41.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$41;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$41() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$41 as $h_Lpresto_TwoFactorAuthView$$anon$41 };
$h_Lpresto_TwoFactorAuthView$$anon$41.prototype = $p;
$p.P = (function() {
  if ((!this.bDi)) {
    this.bDh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bDi = true;
  }
  return this.bDh;
});
var $d_Lpresto_TwoFactorAuthView$$anon$41 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$41, "presto.TwoFactorAuthView$$anon$41", ({
  SD: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$41 as $d_Lpresto_TwoFactorAuthView$$anon$41 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$41.js.map
